import { messages } from '@databases/intl/messages';
import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import noResultsIllustration from '../../../../assets/database_no_results.svg';
import CompactEmptyState from '../../CompactEmptyState';

export const NoResultsState: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <CompactEmptyState
      heading={formatMessage(
        messages['table-layout.no-matching-entries-empty-state-heading']
      )}
      description={formatMessage(
        messages['table-layout.no-matching-entries-empty-state-description']
      )}
      imageUrl={noResultsIllustration}
    />
  );
};
